import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { utility } from '../utility';

export default function TooltipLabel(props) {
  const { title, toolTipValue, value, fontSize, align, ...other } = props;

  return (
    <Tooltip title={toolTipValue} color="neutral" size="md" arrow>
      <Box>
        <MyMLabel fontSize={fontSize} align={align} {...other}>{value ?? ''}</MyMLabel>
      </Box>
    </Tooltip>
  );
}

// 2024.5.8 MyMine Version1.5対応 Add Start
export const GridTooltipCell = React.memo((props) => {
  const { width, toolTipValue} = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown =
      cellValue.current.scrollHeight > cellValue.current.clientHeight ||
      cellValue.current.scrollWidth > cellValue.current.clientWidth;
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      if (nativeEvent.key === 'Escape') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        height: '100%',
        position: 'relative',
        display: 'flex',
      }}
    >
      <Box ref={cellDiv} sx={{ height: '100%', width, display: 'block', position: 'absolute', top: 0 }} />
      <Box ref={cellValue} className='text-truncate' sx={{ zIndex: 9999 }}>
        {props.children}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17}}
        >
          <Paper elevation={1} style={{ backgroundColor: 'rgb(55, 55, 55)', color: 'var(--bs-body-bg)', opacity: '0.9' }}>
            <MyMLabel style={{ padding: 8, fontSize: '0.8rem', wordBreak: 'break-word'}}>
              {toolTipValue.length > 600 ? utility.convertEllipsisFormat(toolTipValue,600) : toolTipValue}
            </MyMLabel>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});
// 2024.5.8 MyMine Version1.5対応 Add End